import { useQuery } from '@tanstack/react-query';
import { getBankAccountInfoService } from '../infra';

export const useGetBankAccountInfo = ({ userId, userType }) => {
  return useQuery({
    queryKey: ['getBankAccount', userId],
    queryFn: () => getBankAccountInfoService({ userId, userType }),
    enabled: !!userId,
    retry: 0,
  });
};
